export { PrescribersPopularCities } from "./PrescribersPopularCities"
